import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuardFn, authMatchGuardFn } from '../../core/guards/auth.guard';

export const content: Routes = [
  {
    path: '',
    canActivate: [authGuardFn],
    children: [
      {
        path: '',
        loadChildren: () =>
          import('../../features/dashboard/dashboard.routes').then((r) => r.dashboardRoutingModule),
        // canMatch: [authMatchGuardFn],
      },
      {
        path: '',
        loadChildren: () =>
          import('../../../app/features/user-management/user-management.routes').then(
            (r) => r.UserManagementRoutingModule
          ),
        // canMatch: [authMatchGuardFn],
      },
      {
        path: 'system-administration',
        loadChildren: () =>
          import('../../../app/features/system-administration/system-administration.routes').then(
            (r) => r.SYSTEM_ADMINISTRATION_ROUTES
          ),
        // canMatch: [authMatchGuardFn],
      },
      {
        path: 'financial-management',
        loadChildren: () =>
          import('../../../app/features/financial-management/financial-management-routes').then(
            (r) => r.FINANCIAL_MANAGEMENT_ROUTES
          ),
        // canMatch: [authMatchGuardFn],
      },
      {
        path: 'human-resources',
        loadChildren: () =>
          import('../../../app/features/human-resources/human-resources-routes').then(
            (r) => r.HUMAN_RESOURCES_ROUTES
          ),
        // canMatch: [authMatchGuardFn],
      },

      {
        path: 'company-settings',
        loadChildren: () =>
          import('../../../app/features/global-configuration/global-configuration.routes').then(
            (r) => r.GLOBAL_CONFIGURATION_ROUTES
          ),
        // canMatch: [authMatchGuardFn],
      },
      {
        path: 'notifications',
        loadChildren: () =>
          import('../../../app/features/notifications/notification-routes').then(
            (r) => r.NOTIFICATION_ROUTES
          ),
        // canMatch: [authMatchGuardFn],
        data: { breadcrumb: 'Notifications' },
      },
      {
        path: 'profile',
        loadChildren: () =>
          import('../../features/user-management/profile/profile-routes').then(
            (m) => m.PROFILE_ROUTES
          ),
        // canMatch: [authMatchGuardFn],
        data: { breadcrumb: 'Profile' },
      },
      {
        path: 'ticket',
        loadChildren: () =>
          import('../../features/ticket/ticket.route').then((m) => m.TICKET_ROUTES),
        // canMatch: [authMatchGuardFn],
        data: { breadcrumb: 'Tickets' },
      },
    ],
  },
];
@NgModule({
  // imports: [RouterModule.forRoot(admin)],
  exports: [RouterModule],
})
export class SaredRoutingModule {}
